import { render, staticRenderFns } from "./WorkTaskFindingItem.vue?vue&type=template&id=b06f3f5c"
import script from "./WorkTaskFindingItem.vue?vue&type=script&lang=ts"
export * from "./WorkTaskFindingItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports